// extracted by mini-css-extract-plugin
export var alertIcon = "_ov-0";